import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocationStrategy } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { PreviousRouteService } from 'src/app/services/previousRouteService';
import Device from 'src/app/services/device.model';
import { DeviceService } from 'src/app/services/device.service';

@Component({
  selector: 'app-wifi',
  templateUrl: './wifi.component.html',
  styleUrls: ['./wifi.component.scss']
})
export class WifiComponent implements OnInit, OnDestroy {
  public device: Device = new Device();
  public addDevice: Device = new Device();
  public devices: Array<Device> = [];

  public objectlength: any;
  public wifiForm: FormGroup;
  public submitted = false;
  public addwifiForm: FormGroup;
  public addwifisubmitted = false;
  public fieldTextType: boolean = false;
  public enableDisablePageLoader: boolean = false;
  public wifiScanLoading: boolean = false;
  public addWifiLoading: boolean = false;

  constructor(
    private toastrService: ToastrService,
    public formBuilder: FormBuilder,
    public deviceService: DeviceService,
    private locationStrategy: LocationStrategy,
    private previousRouteService: PreviousRouteService
  ) {
    this.device = new Device();
    this.addDevice = new Device();

    this.wifiForm = this.formBuilder.group({
      serial_number: ['', Validators.required],
    });

    this.addwifiForm = this.formBuilder.group({
      addserial_number: ['', Validators.required],
      addssid: ['', Validators.required],
      addpassword: ['', Validators.required],
    });
  }

  async ngOnInit() {
    try {
      window.scrollTo(0, 0);
      this.enableDisablePageLoader = true;
      this.previousRouteService.setPreviousRoute(this.locationStrategy.path());
      this.devices = await this.deviceService.getAllDevices();
      this.enableDisablePageLoader = false;
    } catch (error) {
      this.toastrService.error(error?.error?.message || error?.message || error);
      this.enableDisablePageLoader = false;
    }
  }

  public ngOnDestroy(): void {
    this.deviceService.cancelOnGoingHttpRequests();
  }

  get wifiFormValidation() {
    return this.wifiForm.controls;
  }

  get addWifiFormValidation() {
    return this.addwifiForm.controls;
  }

  async addwifi() {
    this.addwifisubmitted = true;
    if (this.addwifiForm.invalid) {
      return;
    }
    try {
      this.addWifiLoading = true;
      const res = await this.deviceService.addNetwork(this.addDevice);
      if (res) {
        this.toastrService.success('Wi-Fi added successfully', '', { timeOut: 2000 });
        this.addwifisubmitted = false;
        this.addwifiForm.reset();
        this.addDevice = new Device();
      }
      this.addWifiLoading = false;
    } catch (error) {
      this.toastrService.error(error?.error?.message || error?.message || error);
      this.addWifiLoading = false;
    }
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  async wifiScan() {
    this.submitted = true;
    if (this.wifiForm.invalid) {
      return;
    }
    try {
      this.wifiScanLoading = true;
      this.device = await this.deviceService.wifiScan(this.device);
      if (this.device) {
        this.objectlength = Object.keys(this.device);
        this.toastrService.success('Wi-Fi scanned successfully', '', { timeOut: 2000 });
        this.submitted = false;
      }
      this.wifiScanLoading = false;
    } catch (error) {
      this.toastrService.error(error?.error?.message || error?.message || error);
      this.wifiScanLoading = false;
    }
  }
}


